import { supertypeClass, property } from '@haventech/amorphic';
import { ExistingPolicy } from './ExistingPolicy';
import { ExistingPolicies } from './ExistingPolicies';
import { ExistingPolicyInForce as GQLExistingPolicyInForce } from '@hit/hit-api-client';

/**
 * Existing policy of status 'In Force'
 * Starting 2019 filing, existing policies are tracked in different lists in ExistingPolicies class based on their status
 * Just filtering them in schema.json would break backwards compatibility
 * Hence a dedicated class based on status so that persistor can distinguish them and group them correctly in their respective lists
 */
@supertypeClass({ toClient: true, toServer: true })
export class ExistingPolicyInForce extends ExistingPolicy implements GQLExistingPolicyInForce {
  @property({ getType: () => ExistingPolicies })
  existingPolicies: ExistingPolicies;

  constructor() {
    super();
  }

  static new(customer) {
    return new ExistingPolicyInForce().init(customer);
  }

  init(customer) {
    this.customer = customer;
    this.status = 'Inforce';
    super.init(customer);
    return this;
  }

  isReplacementTrigger() {
    if (!this.isReplacement && this.cashValueTransfer > 0) {
      this.cashValueTransfer = 0;
      this.customer.application.primaryPolicy.removeExchange1035();
    }
  }
}
